import Routes from "@apis/routes";
import { ProductCategory } from "@utils/constants";

export const getCollectionAPI = (type: ProductCategory) => {
  switch (type) {
    case ProductCategory.DIAMOND:
    case ProductCategory.LAB_GROWN_DIAMOND:
      return Routes.SEARCH_RESULT_DIAMOND;
    case ProductCategory.GEMSTONE:
      return Routes.SEARCH_RESULT_GEMSTONE;
    case ProductCategory.JEWELRY:
      return Routes.SEARCH_RESULT_JEWELRY;
    default:
      return Routes.SEARCH_RESULT_DIAMOND;
  }
};

export const getCollectionPayload = (type: ProductCategory, data: any) => {
  switch (type) {
    case ProductCategory.DIAMOND:
    case ProductCategory.LAB_GROWN_DIAMOND:
      return {
        vdb: data,
      };
    case ProductCategory.GEMSTONE:
      return {
        gemstone: data,
      };
    case ProductCategory.JEWELRY:
      return {
        jewelry: data,
      };
    default:
      return {
        vdb: data,
      };
  }
};

export const getAddToFavoritesAPI = (type: ProductCategory) => {
  switch (type) {
    case ProductCategory.DIAMOND:
    case ProductCategory.LAB_GROWN_DIAMOND:
      return Routes.ADD_DIAMOND_FAVORITES;
    case ProductCategory.GEMSTONE:
      return Routes.ADD_GEMSTONE_FAVORITES;
    case ProductCategory.JEWELRY:
      return Routes.ADD_JEWELRY_FAVORITES;
    default:
      return Routes.ADD_JEWELRY_FAVORITES;
  }
};
